<template>
  <base-dialog v-model="show" @close="close" fullscreen disabledAction>
    <template v-slot:title>{{
      type === EDIT_TYPE.CREATE
        ? 'Tạo bản đồ chia sẻ'
        : 'Cập nhật bản đồ chia sẻ'
    }}</template>
    <template #content>
      <div class="d-flex flex-grow-1" style="min-height: 0">
        <div style="width: 550px" class="pa-4">
          <div class="d-flex flex-column" style="height: 100%">
            <div style="flex: 1; overflow-y: auto; min-height: 0; padding-right: 8px;">
              <base-form ref="form" lazy-validation>
                <div style="font-weight: bold;">Tên bản đồ <span style="color: red">*</span></div>
                <v-text-field outlined v-model="form.map_name" :rules="nameRules" dense placeholder="Nhập tên đề bản đồ"
                  class="mt-1">
                </v-text-field>
                <v-divider class="mt-2 mb-3" />
                <div style="font-weight: bold;">Tiêu đề bản đồ</div>
                <v-text-field outlined hide-details v-model="form.title_map_style.map_title" dense
                  placeholder="Nhập tiêu đề bản đồ" class="mt-1">
                </v-text-field>
                <div class="d-flex mt-4 mb-2">
                  <div class="mr-4">
                    <div>Màu chữ</div>
                    <field-group class="my-1" onlyColor v-model="form.title_map_style.map_title_color"
                      type-input="field-color-picker"></field-group>
                  </div>

                  <div style="flex: 1">
                    <div>Màu nền</div>
                    <field-group class="my-1" onlyColor v-model="form.title_map_style.map_title_bgcolor"
                      type-input="field-color-picker"></field-group>
                  </div>
                </div>
                <v-divider />
                <div class="mt-4">Tiêu đề lớp</div>
                <v-text-field outlined hide-details v-model="form.layer_title" dense class="mt-1"
                  placeholder="Tiêu đề lớp bản đồ">
                </v-text-field>
                <div>
                  <div class="mt-4"></div>
                  <v-checkbox hide-details v-model="form.title_map_style.default_open_label" label="Mặc định bật nhãn">
                  </v-checkbox>
                </div>
                <v-divider class="mt-3" />
                <div class="mt-3" style="font-size: 14px; font-weight: bold;">Tọa độ trung tâm & mức zoom</div>
                <div class="d-flex mt-4 mb-2">
                  <v-text-field outlined hide-details disabled v-model="form.center_lng" dense
                    label="Kinh độ (Longitude )" class="mr-2">
                  </v-text-field>
                  <v-text-field outlined disabled hide-details v-model="form.center_lat" dense label="Vĩ độ (Latitude )"
                    class="ml-2">
                  </v-text-field>
                </div>
                <div class="d-flex mt-4 mb-2">
                  <v-text-field outlined hide-details disabled v-model="form.zoom_level" dense label="Mức Zoom"
                    class="mr-2">
                  </v-text-field>
                  <div style="width: 50%">
                    <v-text-field type="number" outlined hide-details v-model="form.min_zoom" dense
                      label="Mức Zoom nhỏ nhất" style="width: 100%" :min="0" :max="24" class="ml-2">
                    </v-text-field>
                  </div>
                </div>

                <share-legend-editor :mapShareId="form.id"></share-legend-editor>

                <div class="d-flex align-end" style="margin-top: 30px; height: 35px" v-if="type !== EDIT_TYPE.CREATE">
                  <div style="flex: 1">
                    <v-text-field hide-details v-model="link" dense label="Liên kết chia sẻ" style="width: 100%"
                      id="linkshare" readonly @focus="selectLink">
                    </v-text-field>
                  </div>
                  <v-btn color="blue-grey" class="ml-2 white--text" style="height: 100%" @click="copyLink">
                    Sao chép
                    <v-icon right dark>
                      mdi-content-copy
                    </v-icon>
                  </v-btn>
                </div>
              </base-form>
            </div>

            <div class="d-flex justify-space-between mb-1 mt-2">
              <v-btn class="mr-2 text-none" text @click="close">
                {{ $t('actions.cancel') }}
              </v-btn>
              <base-button color="primary" @click="createMapShare">
                {{
                  type === EDIT_TYPE.CREATE ? 'Tạo bản đồ' : 'Cập nhật bản đồ'
                }}
              </base-button>
            </div>
          </div>
        </div>
        <div style="flex: 1" class="pa-4 pt-0">
          <v-card style="width: 100%; height: 100%;" class="mb-2 d-flex flex-column" v-if="show">
            <div>
              <v-app-bar dense elevation="1" class="d-flex justify-center" v-if="form.title_map_style.map_title"
                :color="form.title_map_style.map_title_bgcolor">
                <v-toolbar-title :style="{ color: form.title_map_style.map_title_color }">{{
                  form.title_map_style.map_title }}</v-toolbar-title>
              </v-app-bar>
            </div>
            <Map :layer_ids="layer_ids" @get-position-map="getPositionMap" @get-layer-map="getLayerMap" style="flex: 1"
              :titleLayerControl="form.layer_title" :center="map_position" ref="map" :disableAdvancedSearch="true" />
          </v-card>
        </div>
      </div>
    </template>
    <template #extra-btn>
      <base-button color="primary" @click="createMapShare">
        {{ type === EDIT_TYPE.CREATE ? 'Tạo bản đồ' : 'Cập nhật bản đồ' }}
      </base-button>
    </template>
  </base-dialog>
</template>

<script>
import { callRef } from '@/src/utils'
import { API_MAPSHARE } from '@api'
import { EDIT_TYPE, getCurrentUrl } from '@constant'
import Map from '@views/map/map-main.vue'
import ShareLegendEditor from './share-legend-editor.vue'

export default {
  components: { Map, ShareLegendEditor },
  props: {
    typeLayer: {
      type: String,
      default: () => 'layer_ids',
    },
  },
  data: () => ({
    form: {
      title_map_style: {
        default_open_label: false,
        map_title: null,
        map_title_color: '#F0F3F4',
        map_title_bgcolor: '#78b578',
      },
    },
    nameRules: [(v) => !!v || 'Tên bản đồ không thể bỏ trống'],
    show: false,
    layer_ids: null,
    type: null,
    EDIT_TYPE,
    errors: {},
    link: null,
    map_position: {
      center: [105.19084739818732, 15.827971829957548],
      zoom: 5.297175623863693,
      maxZoom: 22,
    },
  }),
  methods: {
    async open(data, type) {
      this.layer_ids = []
      this.type = type
      this.form = {
        layer_title: 'Lớp bản đồ',
        title_map_style: {
          map_title: null,
          map_title_color: '#F0F3F4',
          map_title_bgcolor: '#78b578',
        },
        center_lat: 15.827971829957548,
        center_lng: 105.19084739818732,
        zoom_level: 5,
        min_zoom: 4,
        meta: {},
      }
      this.form = {
        ...this.form,
        ...data,
        title_map_style: data.title_map_style
          ? data.title_map_style
          : {
            map_title: null,
            map_title_color: '#F0F3F4',
            map_title_bgcolor: '#78b578',
          },
      }
      this.map_position = {
        center: [105.19084739818732, 15.827971829957548],
        zoom: 5.297175623863693,
        maxZoom: 22,
      }
      if (data.center_lat && data.center_lng) {
        this.map_position = {
          center: [data.center_lng, data.center_lat],
          zoom: data.zoom_level ? data.zoom_level : 5,
          maxZoom: 22,
        }
      }
      if (this.form.meta.map) {
        callRef(
          () => this.$refs.map.setDataSave(this.form.meta.map),
          () => this.$refs.map
        )
      }
      this.show = true
      this.link = getCurrentUrl() + `/tu-lieu-ban-do?key=${this.form.key}`
    },
    getPositionMap(centerMap) {
      this.form.center_lat = centerMap.center.lat
      this.form.center_lng = centerMap.center.lng
      this.form.zoom_level = centerMap.zoom
    },
    getLayerMap(layers) {
      this.form.meta = layers
    },
    close() {
      this.show = false
      this.layer_ids = null
    },
    selectLink() {
      const input = document.getElementById('linkshare')
      input.select()
    },
    copyLink() {
      navigator.clipboard.writeText(this.link)
    },
    onDialogClose() {
      this.show = false
      this.loading = false
      this.form = {
        title_map_style: {
          map_title: null,
          map_title_color: '#F0F3F4',
          map_title_bgcolor: '#78b578',
        },
      }
      this.type = this.EDIT_TYPE.CREATE
      this.errors = {}
    },
    async createMapShare() {
      if (!(await this.$refs.form.validate())) return
      try {
        this.form.meta.map = this.$refs.map.getDataSave()
        let res =
          this.type == EDIT_TYPE.CREATE
            ? await API_MAPSHARE.create(this.form)
            : await API_MAPSHARE.update(this.form.id, this.form)

        if (res && !res.error) {
          this.onDialogClose()
          this.getData()
        }
      } finally {
        // this.dialog.loading = false
      }
    },
    getData() {
      this.$emit('reset')
    },
  },
}
</script>

<style scoped></style>
